import { CustomerSucessController } from "@talentbait/shared-components";
import React, { useCallback } from "react";

import Actions from "../Actions";
import ArchivePictureModal from "../Components/Modal/ArchivePictureModal";

const useArchivePictureModal = (
  campaignData,
  userProfile,
  archivePicture,
  isArchivable,
  setFilteredRecent
) => {
  const archivePictureModalCallback = useCallback(
    (url, source) => {
      const { id: campaignId } = campaignData || {};
      const { organizationId } = userProfile || {};

      if (!isArchivable(url)) {
        Actions.addNotification("You cannot delete a selected asset.", "error");
        return;
      }

      // Segment tracking
      CustomerSucessController.send("Archive Image Clicked", {
        organizationId,
        campaignId,
        url,
        source
      });

      const cancelledAction = () => {
        CustomerSucessController.send("Archive Image Cancel", {
          organizationId,
          campaignId,
          url,
          source
        });

        Actions.toggleModal("showGenericModal", false);
      };

      const confirmedAction = () => {
        CustomerSucessController.send("Archive Image Accept", {
          organizationId,
          campaignId,
          url,
          source
        });

        setFilteredRecent((currentFilteredRecent) =>
          currentFilteredRecent.filter((creative) => creative.image_url !== url)
        );

        archivePicture(url, source);

        Actions.toggleModal("showGenericModal", false);
      };

      Actions.toggleModal("showGenericModal", true, {
        headline: "Bild endgültig löschen",
        widthVersion: "small",
        view: (
          <ArchivePictureModal
            confirmedAction={confirmedAction}
            cancelledAction={cancelledAction}
          />
        )
      });
    },
    [campaignData, userProfile, archivePicture, isArchivable, setFilteredRecent]
  );

  return {
    archivePictureModalCallback
  };
};

export default useArchivePictureModal;
